<template>
    <div class="relative flex items-stretch">
        <div class="flex-auto">
            <AdminText v-model="modelValue" v-bind="props" :readonly="true" />
        </div>
        <div v-if="isSupported" class="flex grow-0">
            <Button v-if="!copied" type="button" :size="props.size" dusk="copy-button" @click="copy(modelValue)">
                <icon icon="hero/outline/clipboard" class="w-4 h-4"></icon>
            </Button>
            <Button v-else type="button" :size="props.size" dusk="copy-done" @click="copy(modelValue)">
                <icon icon="hero/outline/check" class="w-4 h-4"></icon>
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ComponentSize } from '@src/Common/DataGrid/types';
import { useClipboard } from '@vueuse/core';

defineOptions({
    inheritAttrs: false,
});

const modelValue = defineModel<string | undefined>();

interface Props {
    placeholder?: string | undefined;
    size?: ComponentSize;
    dusk?: string | null;
    valid?: boolean;
    invalid?: boolean;
    required?: boolean;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    placeholder: undefined,
    size: 'base',
    dusk: null,
    valid: false,
    invalid: false,
});

const { copy, copied, isSupported } = useClipboard({ source: modelValue });
</script>
